import axios from 'axios'

const apiModule = {
  state: {
    menuDataapi: []
  },
  getters: {
    getCategoryByIdapi: state => cateId => {
      return state.menuDataapi.filter(category => {
        return parseInt(category.id) === parseInt(cateId)
      })
    }
  },
  mutations: {
    UPDATE_MENU_DATA_API(state, dataMenu) {
      state.menuDataapi = dataMenu
    }
  },
  actions: {
    async fetchMenuapi(content) {
      try {
        const reponse = await axios.get(
          'https://cafeathome.afourleaf.com/dining/get_menus/6096AA46AAFC4931A3418165DE1741B0/-9999999/0008843251/json/1/'
        )
        const exceptCategory = []
        const menuData = reponse.data.datas
        const filterMenuData = menuData.filter(item => {
          return !exceptCategory.includes(item.id)
        })
        content.commit('UPDATE_MENU_DATA_API', filterMenuData)
        console.log(menuData)
      } catch (err) {
        console.log(err)
      }
    }
  },
  modules: {}
}

export default apiModule
